"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_core_1 = require("@patternfly/react-core");
const ToolbarProgress = ({ style, size = react_core_1.ProgressSize.sm, }) => (react_1.default.createElement(react_core_1.ToolbarGroup, { style: { flexGrow: 1 } },
    react_1.default.createElement(react_core_1.ToolbarItem, { style: { flexGrow: 1 } },
        react_1.default.createElement(react_core_1.Progress, { style: Object.assign(Object.assign({}, style), { gridGap: 0 }), size: size }))));
exports.default = ToolbarProgress;
//# sourceMappingURL=ToolbarProgress.js.map